// src/components/contact-host/contact-host.tsx
function _array_like_to_array(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _array_with_holes(arr) {
  if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _iterable_to_array_limit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _non_iterable_rest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === "function") {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      _define_property(target, key, source[key]);
    });
  }
  return target;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _object_spread_props(target, source) {
  source = source != null ? source : {};
  if (Object.getOwnPropertyDescriptors) {
    Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
  } else {
    ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _sliced_to_array(arr, i) {
  return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _tagged_template_literal(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
function _unsupported_iterable_to_array(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _array_like_to_array(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _templateObject() {
  var data = _tagged_template_literal(["\n  fragment LodgingPolicyPopoverFragment on RatePlanMessage {\n    __typename\n    ... on LodgingPolicyPopover {\n      policyPrimaryText {\n        ...LodgingEGDSInlineLinkFragment\n      }\n      policySecondaryText {\n        ...EGDSStylizedTextFragment\n      }\n      sheetContent {\n        text\n      }\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject1() {
  var data = _tagged_template_literal(["\n  fragment OffersInquiryFormBookNowMessagingFragment on OffersInquiryFormBookNowMessaging {\n    availabilityMessage {\n      ...LodgingEnrichedMessageFragment\n    }\n    availabilityMessageSubText {\n      ...LodgingEnrichedMessageFragment\n    }\n    lodgingPrepareCheckout {\n      checkoutButton {\n        primary\n        accessibility\n        action {\n          analytics {\n            referrerId\n            linkName\n          }\n          ... on UILinkAction {\n            resource {\n              value\n            }\n          }\n        }\n      }\n      action {\n        checkoutOptions {\n          type\n          value\n        }\n        offerTokens {\n          token\n          lineOfBusiness\n        }\n        totalPrice {\n          amount\n          currencyInfo {\n            code\n          }\n        }\n        adaptExSuccessEvents {\n          ...LodgingAdaptExAnalyticsEventFragment\n        }\n        analyticsList {\n          eventType\n          linkName\n          referrerId\n          uisPrimeMessages {\n            messageContent\n            schemaName\n          }\n        }\n        lodgingRecommendationClickstreamEvent {\n          recommendationResponseId\n        }\n        propertyNaturalKeys {\n          id\n          businessModelType\n          checkIn {\n            month\n            day\n            year\n          }\n          checkOut {\n            month\n            day\n            year\n          }\n          inventoryType\n          noCreditCard\n          petsIncluded\n          ratePlanId\n          roomTypeId\n          ratePlanType\n          rooms {\n            childAges\n            numberOfAdults\n          }\n          shoppingPath\n        }\n        moreDetailsAnalyticsList {\n          eventType\n          linkName\n          referrerId\n          uisPrimeMessages {\n            messageContent\n            schemaName\n          }\n        }\n        __typename\n      }\n    }\n    reserveSubText {\n      ...LodgingPolicyPopoverFragment\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject1 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject2() {
  var data = _tagged_template_literal(["\n  fragment ConfirmationScreenFragment on InquiryResponse {\n    __typename\n    header\n    body\n    analytics {\n      linkName\n      referrerId\n      uisPrimeMessages {\n        messageContent\n      }\n    }\n    doneButton {\n      ... on UIPrimaryButton {\n        accessibility\n        primary\n        analytics {\n          linkName\n          referrerId\n          uisPrimeMessages {\n            messageContent\n          }\n        }\n        disabled\n      }\n    }\n  }\n"]);
  _templateObject2 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject3() {
  var data = _tagged_template_literal(["\n  fragment InquiryFormButtonFragment on UIPrimaryButton {\n    __typename\n    primary\n    accessibility\n    analytics {\n      linkName\n      referrerId\n    }\n    disabled\n  }\n"]);
  _templateObject3 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject4() {
  var data = _tagged_template_literal(["\n  fragment OffersInquiryFormDisclaimerFragment on OffersInquiryFormLayout {\n    disclaimer {\n      __typename\n      ...LodgingEGDSTextFragment\n    }\n  }\n  ", "\n"]);
  _templateObject4 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject5() {
  var data = _tagged_template_literal(["\n  fragment EGDSMaxLengthInputValidationFragment on EGDSMaxLengthInputValidation {\n    errorMessage\n    maxLength\n  }\n"]);
  _templateObject5 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject6() {
  var data = _tagged_template_literal(["\n  fragment EGDSMinLengthInputValidationFragment on EGDSMinLengthInputValidation {\n    errorMessage\n    minLength\n  }\n"]);
  _templateObject6 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject7() {
  var data = _tagged_template_literal(["\n  fragment EGDSRegexInputValidationFragment on EGDSRegexInputValidation {\n    errorMessage\n    pattern\n  }\n"]);
  _templateObject7 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject8() {
  var data = _tagged_template_literal(["\n  fragment EGDSRequiredInputValidationFragment on EGDSRequiredInputValidation {\n    errorMessage\n  }\n"]);
  _templateObject8 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject9() {
  var data = _tagged_template_literal(["\n  fragment EGDSInputValidationFragment on EGDSInputValidation {\n    ...EGDSRegexInputValidationFragment\n    ...EGDSMaxLengthInputValidationFragment\n    ...EGDSMinLengthInputValidationFragment\n    ...EGDSRequiredInputValidationFragment\n  }\n\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject9 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject10() {
  var data = _tagged_template_literal(["\n  fragment EGDSContactHostBasicCheckBoxFragment on EGDSBasicCheckBox {\n    egdsElementId\n    description\n    enabled\n    checkedAnalytics {\n      linkName\n      referrerId\n    }\n    uncheckedAnalytics {\n      linkName\n      referrerId\n    }\n    checkboxLabel: label {\n      text\n    }\n    name\n    required\n    state\n  }\n"]);
  _templateObject10 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject11() {
  var data = _tagged_template_literal(["\n  fragment EGDSInputTextFragment on EGDSTextInputField {\n    __typename\n    egdsElementId\n    inputDisabled: disabled\n    label\n    readOnly\n    value\n    placeholder\n    validations {\n      ...EGDSInputValidationFragment\n    }\n  }\n  ", "\n"]);
  _templateObject11 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject12() {
  var data = _tagged_template_literal(["\n  fragment InquiryFormTextAreaFragment on EGDSTextAreaInputField {\n    egdsElementId\n    label\n    readOnly\n    errorMessage\n    minRows\n    maxRows\n    value\n    placeholder\n    validations {\n      ...EGDSInputValidationFragment\n    }\n  }\n  ", "\n"]);
  _templateObject12 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject13() {
  var data = _tagged_template_literal(["\n  fragment EGDSInputSinglSelectFragment on EGDSBasicSelect {\n    __typename\n    disabled\n    egdsElementId\n    label\n    options {\n      value\n      label\n      selected\n    }\n    value\n  }\n"]);
  _templateObject13 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject14() {
  var data = _tagged_template_literal(["\n  fragment OffersInquiryPhoneInputFieldFragment on OffersInquiryPhoneInputField {\n    __typename\n    countryCode {\n      ...EGDSInputSinglSelectFragment\n    }\n    phoneNumber {\n      ...EGDSInputTextFragment\n    }\n  }\n  ", "\n  ", "\n"]);
  _templateObject14 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject15() {
  var data = _tagged_template_literal(["\n  fragment OffersInquiryFormInputElementFragment on OffersInquiryFormInputElement {\n    __typename\n    ...EGDSInputTextFragment\n    ...EGDSContactHostBasicCheckBoxFragment\n    ...InquiryFormTextAreaFragment\n    ...OffersInquiryPhoneInputFieldFragment\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject15 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject16() {
  var data = _tagged_template_literal(["\n  fragment OffersInquiryFormLayoutFragment on OffersInquiryFormLayout {\n    header\n    featuredMessage {\n      ...EGDSStandardMessagingCardFragment\n    }\n    analytics {\n      referrerId\n      linkName\n    }\n    formInput {\n      ...OffersInquiryFormInputElementFragment\n    }\n    ...OffersInquiryFormDisclaimerFragment\n    submitButton {\n      ...InquiryFormButtonFragment\n    }\n    bookNowMessaging {\n      ...OffersInquiryFormBookNowMessagingFragment\n    }\n  }\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"]);
  _templateObject16 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject17() {
  var data = _tagged_template_literal(["\n  mutation InquiryFormMutation($context: ContextInput!, $inquiryRequestInput: InquiryRequestInput!) {\n    submitInquiry(context: $context, inquiryRequest: $inquiryRequestInput) {\n      ...ConfirmationScreenFragment\n    }\n  }\n  ", "\n"]);
  _templateObject17 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject18() {
  var data = _tagged_template_literal(["\n  fragment OffersInquiryFormDialogActionFragment on OffersInquiryFormDialogAction {\n    inquiryFormModal {\n      ...OffersInquiryFormLayoutFragment\n    }\n  }\n  ", "\n"]);
  _templateObject18 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject19() {
  var data = _tagged_template_literal(["\n  fragment OffersContactHostButtonFragment on OffersContactHostButton {\n    button {\n      __typename\n      ... on UISecondaryButton {\n        analytics {\n          ...buttonAnalytics\n        }\n        disabled\n        primary\n      }\n      ... on UITertiaryButton {\n        analytics {\n          ...buttonAnalytics\n        }\n        disabled\n        primary\n      }\n    }\n    action {\n      ... on UILinkAction {\n        analytics {\n          referrerId\n          linkName\n        }\n        resource {\n          value\n        }\n        target\n        useRelativePath\n      }\n      ...OffersInquiryFormDialogActionFragment\n    }\n  }\n  fragment buttonAnalytics on ClientSideAnalytics {\n    eventType\n    linkName\n    referrerId\n    uisPrimeMessages {\n      messageContent\n      schemaName\n    }\n  }\n\n  ", "\n"]);
  _templateObject19 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject20() {
  var data = _tagged_template_literal(["\n  fragment OffersContactHostSectionFragment on OffersContactHostSection {\n    header\n    cta {\n      ...OffersContactHostButtonFragment\n    }\n  }\n\n  ", "\n"]);
  _templateObject20 = function _templateObject() {
    return data;
  };
  return data;
}
function _templateObject21() {
  var data = _tagged_template_literal(["\n  query ContactHostQuery(\n    $context: ContextInput!\n    $prominence: OffersInquiryProminence\n    $inquiryFormInput: OffersInquiryFormInput\n    $propertyId: String!\n    $searchCriteria: PropertySearchCriteriaInput\n    $shoppingContext: ShoppingContextInput\n    $travelAdTrackingInfo: PropertyTravelAdTrackingInfoInput\n    $searchOffer: SearchOfferInput\n    $referrer: String\n  ) {\n    offersContactHost(\n      context: $context\n      prominence: $prominence\n      inquiryFormInput: $inquiryFormInput\n      propertyId: $propertyId\n      referrer: $referrer\n      searchCriteria: $searchCriteria\n      searchOffer: $searchOffer\n      shoppingContext: $shoppingContext\n      travelAdTrackingInfo: $travelAdTrackingInfo\n    ) {\n      ...OffersContactHostSectionFragment\n    }\n  }\n  ", "\n"]);
  _templateObject21 = function _templateObject() {
    return data;
  };
  return data;
}
import React19, { useEffect as useEffect5, useState as useState5 } from "react";
import { gql as gql21, useQuery } from "@apollo/client";
import { useBexApi as useBexApi2 } from "@shared-ui/bex-api-context";
// src/components/contact-host/__private/__fragments/contact-host-context.tsx
import React, { createContext, useContext, useState } from "react";
var ContactHostContext = createContext(null);
var ContactHostContextProvider = function (param) {
  var children = param.children;
  var _useState = _sliced_to_array(useState(""), 2),
    propertyId = _useState[0],
    setPropertyId = _useState[1];
  var _useState1 = _sliced_to_array(useState(false), 2),
    isInquiryRoute = _useState1[0],
    setIsInquiryRoute = _useState1[1];
  var _useState2 = _sliced_to_array(useState(void 0), 2),
    inquiryUpdatedFields = _useState2[0],
    setInquiryUpdatedFields = _useState2[1];
  var _useState3 = _sliced_to_array(useState(void 0), 2),
    inputs = _useState3[0],
    setInputs = _useState3[1];
  var _useState4 = _sliced_to_array(useState(void 0), 2),
    variables = _useState4[0],
    setVariables = _useState4[1];
  var _useState5 = _sliced_to_array(useState(false), 2),
    isLoading = _useState5[0],
    setIsLoading = _useState5[1];
  var value = {
    propertyId: propertyId,
    isInquiryRoute: isInquiryRoute,
    inquiryUpdatedFields: inquiryUpdatedFields,
    inputs: inputs,
    setPropertyId: setPropertyId,
    setIsInquiryRoute: setIsInquiryRoute,
    setInquiryUpdatedFields: setInquiryUpdatedFields,
    setInputs: setInputs,
    variables: variables,
    setVariables: setVariables,
    isLoading: isLoading,
    setIsLoading: setIsLoading
  };
  return /* @__PURE__ */React.createElement(ContactHostContext.Provider, {
    value: value
  }, children);
};
var useContactHostContext = function () {
  var context = useContext(ContactHostContext);
  if (!context) {
    throw new Error("useContactHostContext can only be used inside ContactHostContextProvider");
  }
  return context;
};
// src/components/contact-host/__private/__fragments/contact-host-section.tsx
import React18 from "react";
import { gql as gql20 } from "@apollo/client";
import { EGDSCard as EGDSCard2, EGDSCardContentSection as EGDSCardContentSection2 } from "@egds/react-core/cards";
import { EGDSLayoutGrid, EGDSLayoutGridItem as EGDSLayoutGridItem2 } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing5 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading3 } from "@egds/react-core/text";
// src/components/contact-host/__private/__fragments/contact-host-button.tsx
import React17, { useEffect as useEffect4, useRef as useRef2, useState as useState4 } from "react";
import { useLocation } from "react-router-dom";
import { gql as gql19 } from "@apollo/client";
import { EGDSSecondaryButton, EGDSTertiaryButton as EGDSTertiaryButton2 } from "@egds/react-core/button";
import { useClickTracker as useClickTracker4 } from "@shared-ui/clickstream-analytics-context";
import { useDialog as useDialog2 } from "@shared-ui/dialog-context";
// src/components/contact-host/__private/__fragments/contact-host-inquiry-form-dialog.tsx
import React16, { useEffect as useEffect3, useRef } from "react";
import { gql as gql18 } from "@apollo/client";
import { EGDSSheet as EGDSSheet2, EGDSSheetContent as EGDSSheetContent2, EGDSSheetTransition as EGDSSheetTransition2 } from "@egds/react-core/sheet";
import { EGDSToolbar } from "@egds/react-core/toolbar";
import { useEgClickstream as useEgClickstream2 } from "@shared-ui/clickstream-analytics-context";
import { useDialog } from "@shared-ui/dialog-context";
import { useViewportMap as useViewportMap2, ViewSizes as ViewSizes2 } from "@shared-ui/viewport-context";
// src/utils/eg-clickstream-helpers.tsx
var IMPRESSION = "Impression";
var SCHEMA_NAME = "event";
var buildEvent = function (schemaName, eventName, eventType, eventVersion) {
  return {
    event: {
      schema_name: schemaName,
      event_name: eventName,
      event_type: eventType,
      event_version: eventVersion
    }
  };
};
var inquiryFormViewedEvent = function () {
  return buildEvent(SCHEMA_NAME, "ContactHostInquiryFormViewed", IMPRESSION, "1.0.0" /* ONE_ZERO_ZERO */);
};
// src/components/contact-host/__private/__fragments/inquiry-form/inquiry-form.tsx
import React15, { useMemo } from "react";
import { gql as gql17, useMutation } from "@apollo/client";
import { EGDSForm } from "@egds/react-core/form";
import { EGDSLayoutFlex as EGDSLayoutFlex4, EGDSLayoutFlexItem as EGDSLayoutFlexItem4 } from "@egds/react-core/layout-flex";
import { EGDSSpacing as EGDSSpacing4 } from "@egds/react-core/spacing";
import { EGDSHeading as EGDSHeading2 } from "@egds/react-core/text";
import { useBexApi } from "@shared-ui/bex-api-context";
import { useEgClickstream } from "@shared-ui/clickstream-analytics-context";
import { Experiment, ExperimentControl, ExperimentVariant, useExperiment } from "@shared-ui/experiment-context";
import { EGDSStandardMessagingCard } from "@shared-ui/lodging-fragments";
import { TravelerSelector } from "@shared-ui/lodging-property-offers";
import { PropertyAvailability } from "@shared-ui/retail-lodging-property-availability";
// src/components/contact-host/__private/__fragments/controls/utils/helpers.tsx
import { DayName } from "@egds/react-core/date-picker";
var _obj;
var EGDSDayNameMap = (_obj = {}, _define_property(_obj, "SUN" /* SUN */, DayName.SUN), _define_property(_obj, "MON" /* MON */, DayName.MON), _define_property(_obj, "TUE" /* TUE */, DayName.TUE), _define_property(_obj, "WED" /* WED */, DayName.WED), _define_property(_obj, "THU" /* THU */, DayName.THU), _define_property(_obj, "FRI" /* FRI */, DayName.FRI), _define_property(_obj, "SAT" /* SAT */, DayName.SAT), _obj);
var parseDate = function (date) {
  return {
    day: date.getDate(),
    month: date.getMonth() + 1,
    year: date.getFullYear()
  };
};
// src/components/contact-host/__private/__fragments/inquiry-form/utils/inquiry-forms-utils.tsx
var inquiryFormFieldSelector = {
  PHONE_NUMBER: "inquirerPhoneNumber",
  COUNTRY_CODE: "inquirerPhoneCountryCode",
  MESSAGE: "message",
  NEWS_LETTER_SUBSCRIBE: "optInForMarketing",
  PETS_TRAVELERS: "petsAllowed"
};
var clearSpaces = function (text) {
  return text.trim().replace(/\s+/g, " ");
};
function validateAndGetValues(typename, value, existingControlValue) {
  if (existingControlValue !== void 0) {
    var existingValue = String(existingControlValue);
    if (existingValue !== value) {
      return {
        isValueUpdated: true,
        currentValue: String(value)
      };
    }
  }
  return {
    isValueUpdated: false,
    currentValue: String(value)
  };
}
var payloadToRoomInput = function (travelerSelectorPayload) {
  return {
    adults: travelerSelectorPayload.adults,
    children: travelerSelectorPayload.children.map(function (item) {
      var _item_split = _sliced_to_array(item.split("_"), 2),
        age = _item_split[1];
      return {
        age: age ? +age : 1
      };
    })
  };
};
var buildPrimaryPropertyCriteriaPayload = function (formState, propertyId) {
  var _requestFieldItems_message;
  var requestFieldItems = {};
  Object.values((formState === null || formState === void 0 ? void 0 : formState.formValue) || {}).forEach(function (item) {
    if (item.typename === "EGDSBasicSelect") {
      var _item_options;
      var selectedOption = (_item_options = item.options) === null || _item_options === void 0 ? void 0 : _item_options.find(function (x) {
        return x.label === item.value;
      });
      requestFieldItems[item.id] = (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.value) || "+1";
    } else if (item.typename === "EGDSBasicCheckBox") {
      requestFieldItems[item.id] = item.checked;
    } else {
      requestFieldItems[item.id] = item.value;
    }
  });
  var dateRange = null;
  var rooms;
  var petsIncluded;
  var travelerSelector = formState.travelerSelector,
    datePickerAvailability = formState.datePickerAvailability;
  if ((datePickerAvailability === null || datePickerAvailability === void 0 ? void 0 : datePickerAvailability.checkInDate) && (datePickerAvailability === null || datePickerAvailability === void 0 ? void 0 : datePickerAvailability.checkOutDate)) {
    dateRange = {
      checkInDate: datePickerAvailability.checkInDate,
      checkOutDate: datePickerAvailability.checkOutDate
    };
  }
  if (travelerSelector) {
    rooms = [payloadToRoomInput(travelerSelector)];
    petsIncluded = travelerSelector.isPetsIncluded;
  }
  var primaryPropertyCriteriaInput = {
    rooms: rooms,
    destination: {
      propertyIds: [propertyId]
    },
    dateRange: dateRange
  };
  return _object_spread_props(_object_spread({}, requestFieldItems), {
    message: ((_requestFieldItems_message = requestFieldItems.message) === null || _requestFieldItems_message === void 0 ? void 0 : _requestFieldItems_message.toString()) || "",
    primaryPropertyCriteriaInput: primaryPropertyCriteriaInput,
    petsIncluded: petsIncluded
  });
};
// src/components/contact-host/__private/__fragments/contact-host-book-now-messaging.tsx
import React3 from "react";
import { gql as gql2 } from "@apollo/client";
import { EGDSCard, EGDSCardContentSection } from "@egds/react-core/cards";
import { EGDSLayoutFlex, EGDSLayoutFlexItem } from "@egds/react-core/layout-flex";
import { UitkLayoutPosition } from "@egds/react-core/layout-position";
import { EGDSLink } from "@egds/react-core/link";
import { EGDSSpacing } from "@egds/react-core/spacing";
import { EGDSText } from "@egds/react-core/text";
import { AdaptExAnalyticsEventFragment, LodgingEGDSInlineLink as LodgingEGDSInlineLink2, LodgingEnrichedMessage } from "@shared-ui/lodging-fragments";
import { PropertyLodgingPrepareCheckout } from "@shared-ui/lodging-property-offers";
import { useViewportMap, ViewSizes } from "@shared-ui/viewport-context";
// src/components/contact-host/__private/__fragments/lodging-policy-popover.tsx
import React2 from "react";
import { gql } from "@apollo/client";
import { EGDSTertiaryButton } from "@egds/react-core/button";
import { EGDSIcon } from "@egds/react-core/icons";
import { EGDSLayoutPosition } from "@egds/react-core/layout-position";
import { EGDSSheet, EGDSSheetCloseButton, EGDSSheetContent, EGDSSheetTransition } from "@egds/react-core/sheet";
import { EGDSParagraph } from "@egds/react-core/text";
import { EGDSStylizedText, LodgingEGDSInlineLink } from "@shared-ui/lodging-fragments";
var fragment = gql(_templateObject(), LodgingEGDSInlineLink.fragment, EGDSStylizedText.fragment);
var LodgingPolicyPopover = function (param) {
  var data = param.data,
    isSmallViewSize = param.isSmallViewSize,
    visible = param.visible,
    toggleVisibility = param.toggleVisibility,
    triggerRef = param.triggerRef;
  var _data_sheetContent;
  return /* @__PURE__ */React2.createElement(EGDSLayoutPosition, {
    type: "absolute",
    position: isSmallViewSize ? {
      zindex: "layer1"
    } : {
      right: "center",
      bottom: "six",
      zindex: "layer1"
    }
  }, /* @__PURE__ */React2.createElement(EGDSSheetTransition, {
    isVisible: visible
  }, /* @__PURE__ */React2.createElement(EGDSSheet, {
    isVisible: visible,
    type: isSmallViewSize ? "bottom" : "popover",
    triggerRef: triggerRef,
    onDismiss: toggleVisibility,
    width: 360
  }, /* @__PURE__ */React2.createElement(EGDSSheetCloseButton, null, /* @__PURE__ */React2.createElement(EGDSTertiaryButton, {
    type: "button",
    onClick: toggleVisibility
  }, /* @__PURE__ */React2.createElement(EGDSIcon, {
    name: "close",
    title: "Close Sheet",
    id: "sheet-close-button"
  }))), (data === null || data === void 0 ? void 0 : data.__typename) === "LodgingPolicyPopover" && /* @__PURE__ */React2.createElement(EGDSSheetContent, {
    padded: true
  }, data === null || data === void 0 ? void 0 : (_data_sheetContent = data.sheetContent) === null || _data_sheetContent === void 0 ? void 0 : _data_sheetContent.map(function (paragraph, index) {
    return /* @__PURE__ */React2.createElement(EGDSParagraph, {
      key: index
    }, paragraph.text);
  })))));
};
LodgingPolicyPopover.displayName = "LodgingPolicyPopover";
LodgingPolicyPopover.fragment = fragment;
var lodging_policy_popover_default = LodgingPolicyPopover;
// src/components/contact-host/__private/__fragments/contact-host-book-now-messaging.tsx
var fragment2 = gql2(_templateObject1(), LodgingEnrichedMessage.fragment, LodgingEGDSInlineLink2.fragment, lodging_policy_popover_default.fragment, AdaptExAnalyticsEventFragment);
var OffersInquiryFormBookNowMessaging = function (param) {
  var data = param.data;
  var _reserveSubText_policyPrimaryText, _reserveSubText_policySecondaryText;
  var reserveSubText = data.reserveSubText,
    availabilityMessage = data.availabilityMessage,
    availabilityMessageSubText = data.availabilityMessageSubText,
    lodgingPrepareCheckout = data.lodgingPrepareCheckout;
  var isBordered = !!lodgingPrepareCheckout;
  var _React3_useState = _sliced_to_array(React3.useState(false), 2),
    visible = _React3_useState[0],
    setVisible = _React3_useState[1];
  var triggerRef = React3.useRef(null);
  var _obj;
  var isSmallViewSize = useViewportMap((_obj = {}, _define_property(_obj, ViewSizes.SMALL, true), _define_property(_obj, ViewSizes.MEDIUM, true), _define_property(_obj, ViewSizes.LARGE, false), _obj));
  var toggleVisibility = function () {
    setVisible(!visible);
  };
  return /* @__PURE__ */React3.createElement(UitkLayoutPosition, {
    type: "relative"
  }, /* @__PURE__ */React3.createElement(EGDSCard, {
    border: isBordered
  }, /* @__PURE__ */React3.createElement(EGDSCardContentSection, {
    padded: false
  }, /* @__PURE__ */React3.createElement(EGDSSpacing, {
    padding: {
      block: "four",
      inline: "six"
    }
  }, /* @__PURE__ */React3.createElement(EGDSCardContentSection, {
    padded: false
  }, /* @__PURE__ */React3.createElement(EGDSLayoutFlex, {
    direction: isSmallViewSize ? "column" : "row",
    alignItems: "center",
    justifyContent: "space-between",
    space: "three",
    wrap: "nowrap"
  }, /* @__PURE__ */React3.createElement(EGDSLayoutFlexItem, {
    grow: 1,
    alignSelf: "center",
    minWidth: isSmallViewSize ? void 0 : "88x"
  }, /* @__PURE__ */React3.createElement(EGDSLayoutFlex, {
    direction: "column",
    alignItems: isSmallViewSize ? "center" : void 0
  }, availabilityMessage && /* @__PURE__ */React3.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React3.createElement(EGDSSpacing, {
    padding: {
      inline: "two"
    }
  }, /* @__PURE__ */React3.createElement("div", null, /* @__PURE__ */React3.createElement(LodgingEnrichedMessage, {
    data: availabilityMessage,
    textSize: 400
  })))), availabilityMessageSubText && /* @__PURE__ */React3.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React3.createElement(EGDSSpacing, {
    padding: {
      inline: isSmallViewSize ? void 0 : "eight"
    }
  }, /* @__PURE__ */React3.createElement("div", null, /* @__PURE__ */React3.createElement(LodgingEnrichedMessage, {
    data: availabilityMessageSubText,
    textSize: 300
  })))))), /* @__PURE__ */React3.createElement(EGDSLayoutFlexItem, null, /* @__PURE__ */React3.createElement(EGDSLayoutFlex, {
    alignItems: isSmallViewSize ? "center" : "end",
    justifyContent: "end",
    direction: "column"
  }, lodgingPrepareCheckout && /* @__PURE__ */React3.createElement(PropertyLodgingPrepareCheckout, {
    data: lodgingPrepareCheckout,
    priceDetailsPropertyNaturalKeys: []
  }), reserveSubText && reserveSubText.__typename === "LodgingPolicyPopover" && /* @__PURE__ */React3.createElement(UitkLayoutPosition, {
    type: "relative"
  }, /* @__PURE__ */React3.createElement(EGDSSpacing, {
    margin: {
      inlineend: "one",
      blockstart: "one"
    }
  }, /* @__PURE__ */React3.createElement(EGDSLink, {
    onClick: toggleVisibility,
    domRef: triggerRef,
    inline: true
  }, /* @__PURE__ */React3.createElement("button", {
    type: "button"
  }, /* @__PURE__ */React3.createElement(EGDSText, {
    size: 200,
    theme: "default"
  }, reserveSubText === null || reserveSubText === void 0 ? void 0 : (_reserveSubText_policyPrimaryText = reserveSubText.policyPrimaryText) === null || _reserveSubText_policyPrimaryText === void 0 ? void 0 : _reserveSubText_policyPrimaryText.text)))), /* @__PURE__ */React3.createElement(EGDSSpacing, null, (reserveSubText === null || reserveSubText === void 0 ? void 0 : (_reserveSubText_policySecondaryText = reserveSubText.policySecondaryText) === null || _reserveSubText_policySecondaryText === void 0 ? void 0 : _reserveSubText_policySecondaryText.text) && /* @__PURE__ */React3.createElement(EGDSText, {
    theme: "default",
    size: 200,
    inline: true
  }, reserveSubText.policySecondaryText.text)))))))))), (reserveSubText === null || reserveSubText === void 0 ? void 0 : reserveSubText.__typename) === "LodgingPolicyPopover" && /* @__PURE__ */React3.createElement(lodging_policy_popover_default, {
    isSmallViewSize: isSmallViewSize,
    visible: visible,
    toggleVisibility: toggleVisibility,
    triggerRef: triggerRef,
    data: reserveSubText
  }));
};
OffersInquiryFormBookNowMessaging.displayName = "OffersInquiryFormBookNowMessaging";
OffersInquiryFormBookNowMessaging.fragment = fragment2;
// src/components/contact-host/__private/__fragments/controls/confirmation-screen.tsx
import React4, { useEffect } from "react";
import { gql as gql3 } from "@apollo/client";
import { EGDSButtonSize, EGDSPrimaryButton } from "@egds/react-core/button";
import { EGDSIcon as EGDSIcon2, EGDSIconSize } from "@egds/react-core/icons";
import { EGDSLayoutFlex as EGDSLayoutFlex2, EGDSLayoutFlexItem as EGDSLayoutFlexItem2 } from "@egds/react-core/layout-flex";
import { EGDSLayoutGridItem } from "@egds/react-core/layout-grid";
import { EGDSSpacing as EGDSSpacing2 } from "@egds/react-core/spacing";
import { EGDSHeading, EGDSText as EGDSText2 } from "@egds/react-core/text";
import { useClickTracker } from "@shared-ui/clickstream-analytics-context";
import { ViewMedium, Viewport, ViewSmall } from "@shared-ui/viewport-context";
var __Fragment = gql3(_templateObject2());
var RenderHeader = React4.memo(function (props) {
  return /* @__PURE__ */React4.createElement(React4.Fragment, null, /* @__PURE__ */React4.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React4.createElement("div", {
    "data-stid": "done-icon"
  }, /* @__PURE__ */React4.createElement(EGDSIcon2, {
    name: "done",
    size: EGDSIconSize.MEDIUM,
    theme: "positive",
    spotlight: "standard"
  }))), /* @__PURE__ */React4.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React4.createElement(EGDSSpacing2, null, /* @__PURE__ */React4.createElement(EGDSHeading, {
    size: 6
  }, props.header))));
});
RenderHeader.displayName = "RenderHeader";
var ConfirmationScreen = function (param) {
  var data = param.data,
    onDialogClose = param.onDialogClose;
  var _analytics_uisPrimeMessages_, _analytics_uisPrimeMessages;
  var body = data.body,
    header = data.header,
    doneButton = data.doneButton,
    analytics = data.analytics;
  var track = useClickTracker();
  var productId = analytics === null || analytics === void 0 ? void 0 : (_analytics_uisPrimeMessages = analytics.uisPrimeMessages) === null || _analytics_uisPrimeMessages === void 0 ? void 0 : (_analytics_uisPrimeMessages_ = _analytics_uisPrimeMessages[0]) === null || _analytics_uisPrimeMessages_ === void 0 ? void 0 : _analytics_uisPrimeMessages_.messageContent;
  var transformedUISMessage = [{
    messageContent: productId ? JSON.parse('{"productId":'.concat(productId, "}")) : "{}",
    schemaName: "hotelProduct"
  }];
  var handleClick = function () {
    if (doneButton === null || doneButton === void 0 ? void 0 : doneButton.analytics) {
      var _doneButton_analytics = doneButton.analytics,
        referrerId = _doneButton_analytics.referrerId,
        linkName = _doneButton_analytics.linkName;
      track(referrerId, linkName, void 0, transformedUISMessage);
    }
    onDialogClose();
  };
  useEffect(function () {
    if (analytics) {
      track(analytics.referrerId, analytics.linkName, void 0, transformedUISMessage);
    }
  }, []);
  return /* @__PURE__ */React4.createElement(React4.Fragment, null, /* @__PURE__ */React4.createElement(EGDSLayoutGridItem, null, /* @__PURE__ */React4.createElement(EGDSSpacing2, null, /* @__PURE__ */React4.createElement(Viewport, null, /* @__PURE__ */React4.createElement(ViewMedium, null, /* @__PURE__ */React4.createElement(EGDSLayoutFlex2, {
    space: "two",
    alignItems: "center",
    justifyContent: "center"
  }, /* @__PURE__ */React4.createElement(RenderHeader, {
    header: header
  }))), /* @__PURE__ */React4.createElement(ViewSmall, null, /* @__PURE__ */React4.createElement(EGDSLayoutFlex2, {
    space: "two",
    alignItems: "center",
    justifyContent: "start"
  }, /* @__PURE__ */React4.createElement(RenderHeader, {
    header: header
  })))))), /* @__PURE__ */React4.createElement(EGDSLayoutFlexItem2, null, /* @__PURE__ */React4.createElement(EGDSSpacing2, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React4.createElement(EGDSLayoutFlex2, {
    justifyContent: "center"
  }, /* @__PURE__ */React4.createElement(EGDSLayoutFlexItem2, {
    maxWidth: "180x"
  }, /* @__PURE__ */React4.createElement("div", null, body === null || body === void 0 ? void 0 : body.map(function (element, index) {
    return /* @__PURE__ */React4.createElement(EGDSSpacing2, {
      margin: "two",
      key: index
    }, /* @__PURE__ */React4.createElement(Viewport, null, /* @__PURE__ */React4.createElement(ViewMedium, null, /* @__PURE__ */React4.createElement(EGDSText2, {
      size: 300
    }, element)), /* @__PURE__ */React4.createElement(ViewSmall, null, /* @__PURE__ */React4.createElement(EGDSText2, {
      size: 200
    }, element))));
  })))))), doneButton && /* @__PURE__ */React4.createElement(EGDSSpacing2, {
    padding: "six"
  }, /* @__PURE__ */React4.createElement("div", null, /* @__PURE__ */React4.createElement(EGDSLayoutFlex2, {
    alignItems: "center",
    justifyContent: "center"
  }, /* @__PURE__ */React4.createElement(EGDSLayoutFlexItem2, {
    alignSelf: "center",
    maxWidth: "quarter_width"
  }, /* @__PURE__ */React4.createElement(EGDSPrimaryButton, {
    "data-stid": "contact-host-done-button",
    "aria-label": doneButton.accessibility || "",
    onClick: handleClick,
    isFullWidth: true,
    size: EGDSButtonSize.LARGE
  }, doneButton.primary))))));
};
ConfirmationScreen.displayName = "ConfirmationScreen";
ConfirmationScreen.fragment = __Fragment;
// src/components/contact-host/__private/__fragments/controls/inquiry-form-button.tsx
import React5 from "react";
import { gql as gql4 } from "@apollo/client";
import { EGDSButtonSize as EGDSButtonSize2, EGDSPrimaryButton as EGDSPrimaryButton2 } from "@egds/react-core/button";
import { EGDSLoader } from "@egds/react-core/loader";
import { useClickTracker as useClickTracker2 } from "@shared-ui/clickstream-analytics-context";
var __Fragment2 = gql4(_templateObject3());
var InquiryFormButton = function (param) {
  var data = param.data,
    localDisabled = param.localDisabled,
    onClick = param.onClick,
    showLoader = param.showLoader;
  var track = useClickTracker2();
  var primary = data.primary,
    analytics = data.analytics,
    accessibility = data.accessibility,
    disabled = data.disabled;
  if (!primary) {
    return null;
  }
  var handleOnClick = function () {
    if (analytics) {
      track(analytics.referrerId, analytics.linkName);
    }
    onClick();
  };
  return /* @__PURE__ */React5.createElement(EGDSPrimaryButton2, {
    type: "button",
    onClick: handleOnClick,
    disabled: localDisabled || disabled,
    isFullWidth: true,
    size: EGDSButtonSize2.LARGE,
    "aria-label": accessibility || ""
  }, showLoader ? /* @__PURE__ */React5.createElement(EGDSLoader, {
    isDarkBackground: true
  }) : data.primary);
};
InquiryFormButton.displayName = "InquiryFormButton";
InquiryFormButton.fragment = __Fragment2;
// src/components/contact-host/__private/__fragments/controls/inquiry-form-disclaimer.tsx
import React6 from "react";
import { gql as gql5 } from "@apollo/client";
import { EGDSSpacing as EGDSSpacing3 } from "@egds/react-core/spacing";
import { LodgingEGDSText } from "@shared-ui/lodging-fragments";
var __InquiryFormDisclaimerFragment = gql5(_templateObject4(), LodgingEGDSText.fragment);
var InquiryFormDisclaimer = function (param) {
  var data = param.data;
  var disclaimer = data.disclaimer;
  if (!disclaimer || disclaimer.length === 0) {
    return null;
  }
  return /* @__PURE__ */React6.createElement(EGDSSpacing3, {
    margin: {
      block: "four"
    }
  }, /* @__PURE__ */React6.createElement("div", null, disclaimer.map(function (element, index) {
    return /* @__PURE__ */React6.createElement("span", {
      key: index
    }, /* @__PURE__ */React6.createElement(LodgingEGDSText, {
      key: element.__typename,
      data: element
    }));
  })));
};
InquiryFormDisclaimer.fragment = __InquiryFormDisclaimerFragment;
InquiryFormDisclaimer.displayName = "InquiryFormDisclaimer";
// src/components/contact-host/__private/__fragments/inquiry-form/context/inquiry-form-context.tsx
import React7, { useCallback, useState as useState2 } from "react";
// src/components/contact-host/__private/__fragments/validation/egds-input-validation.tsx
import { gql as gql10 } from "@apollo/client";
// src/components/contact-host/__private/__fragments/validation/egds-max-length-input-validation.tsx
import { gql as gql6 } from "@apollo/client";
var fragment3 = gql6(_templateObject5());
var defaultValidator = function (value, validation) {
  if (value && value.length > validation.maxLength) {
    return {
      invalid: validation.errorMessage
    };
  }
  return {};
};
var EGDSMaxLengthInputValidation = function (validation) {
  return function (value) {
    return defaultValidator(value, validation);
  };
};
EGDSMaxLengthInputValidation.fragment = fragment3;
// src/components/contact-host/__private/__fragments/validation/egds-min-length-input-validation.tsx
import { gql as gql7 } from "@apollo/client";
var fragment4 = gql7(_templateObject6());
var defaultValidator2 = function (value, validation) {
  if (value && value.length < validation.minLength) {
    return {
      invalid: validation.errorMessage
    };
  }
  return {};
};
var EGDSMinLengthInputValidation = function (validation) {
  return function (value) {
    return defaultValidator2(value, validation);
  };
};
EGDSMinLengthInputValidation.fragment = fragment4;
// src/components/contact-host/__private/__fragments/validation/egds-regex-input-validation.tsx
import { gql as gql8 } from "@apollo/client";
var fragment5 = gql8(_templateObject7());
var defaultValidator3 = function (value, validation) {
  var re = new RegExp(validation.pattern);
  if ((value === null || value === void 0 ? void 0 : value.trim()) && !value.match(re)) {
    return {
      invalid: validation.errorMessage
    };
  }
  return {};
};
var EGDSRegexInputValidation = function (validation) {
  return function (value) {
    return defaultValidator3(value, validation);
  };
};
EGDSRegexInputValidation.fragment = fragment5;
// src/components/contact-host/__private/__fragments/validation/egds-required-input-validation.tsx
import { gql as gql9 } from "@apollo/client";
var fragment6 = gql9(_templateObject8());
var defaultValidator4 = function (value, validation) {
  if (!value || !(value === null || value === void 0 ? void 0 : value.trim())) {
    return {
      invalid: validation.errorMessage
    };
  }
  return {};
};
var EGDSRequiredInputValidation = function (validation) {
  return function (value) {
    return defaultValidator4(value, validation);
  };
};
EGDSRequiredInputValidation.fragment = fragment6;
// src/components/contact-host/__private/__fragments/validation/egds-input-validation.tsx
var fragment7 = gql10(_templateObject9(), EGDSRegexInputValidation.fragment, EGDSRequiredInputValidation.fragment, EGDSMaxLengthInputValidation.fragment, EGDSMinLengthInputValidation.fragment);
var getValidators = function (validations) {
  return validations.map(function (validation) {
    switch (validation.__typename) {
      case "EGDSRegexInputValidation":
        return _object_spread_props(_object_spread({}, validation), {
          validate: EGDSRegexInputValidation(validation)
        });
      case "EGDSMaxLengthInputValidation":
        return _object_spread_props(_object_spread({}, validation), {
          validate: EGDSMaxLengthInputValidation(validation)
        });
      case "EGDSMinLengthInputValidation":
        return _object_spread_props(_object_spread({}, validation), {
          validate: EGDSMinLengthInputValidation(validation)
        });
      case "EGDSRequiredInputValidation":
        return _object_spread_props(_object_spread({}, validation), {
          validate: EGDSRequiredInputValidation(validation)
        });
      default:
        return {
          validate: function () {
            return {};
          }
        };
    }
  });
};
// src/components/contact-host/__private/__fragments/validation/get-clientside-validations.tsx
var getClientsideValidations = function () {
  var validations = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  var validators = validations ? getValidators(validations) : [];
  return {
    actOnServerDefinedValidation: function (value) {
      var primary = {};
      validators.forEach(function (validator) {
        if (!primary.invalid) {
          primary = validator.validate(value);
        }
      });
      return primary;
    }
  };
};
// src/components/contact-host/__private/__fragments/inquiry-form/context/inquiry-form-context.tsx
var returnInitialStateObject = function (id, typename, value) {
  var validations = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
  return {
    id: id,
    typename: typename,
    value: value,
    validations: validations
  };
};
var getFormStateData = function (formData, datePickerAvailability, travelerSelector) {
  var updatedFormData = formData === null || formData === void 0 ? void 0 : formData.reduce(function (acc, item) {
    var initialFormData = _object_spread({}, acc);
    if (item.__typename === "EGDSBasicCheckBox") {
      var _item_egdsElementId;
      var egdsElementId = (_item_egdsElementId = item.egdsElementId) !== null && _item_egdsElementId !== void 0 ? _item_egdsElementId : inquiryFormFieldSelector.NEWS_LETTER_SUBSCRIBE;
      initialFormData[egdsElementId] = _object_spread_props(_object_spread({}, returnInitialStateObject(egdsElementId, item.__typename, item.state === "CHECKED")), {
        checked: item.state === "CHECKED"
      });
    } else if (item.__typename === "OffersInquiryPhoneInputField") {
      var _countryCode_options;
      var countryCode = item.countryCode,
        phoneNumber = item.phoneNumber;
      var _countryCode_egdsElementId;
      var countryCodeEgdsElementId = (_countryCode_egdsElementId = countryCode.egdsElementId) !== null && _countryCode_egdsElementId !== void 0 ? _countryCode_egdsElementId : inquiryFormFieldSelector.COUNTRY_CODE;
      var selectedOption = (_countryCode_options = countryCode.options) === null || _countryCode_options === void 0 ? void 0 : _countryCode_options.find(function (x) {
        return x.selected;
      });
      var _selectedOption_label;
      initialFormData[countryCodeEgdsElementId] = _object_spread_props(_object_spread({}, returnInitialStateObject(countryCodeEgdsElementId, countryCode.__typename, (_selectedOption_label = selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label) !== null && _selectedOption_label !== void 0 ? _selectedOption_label : "")), {
        options: countryCode.options
      });
      var _phoneNumber_egdsElementId;
      var phoneNumberEgdsElementId = (_phoneNumber_egdsElementId = phoneNumber.egdsElementId) !== null && _phoneNumber_egdsElementId !== void 0 ? _phoneNumber_egdsElementId : inquiryFormFieldSelector.PHONE_NUMBER;
      initialFormData[phoneNumberEgdsElementId] = returnInitialStateObject(phoneNumberEgdsElementId, phoneNumber.__typename, phoneNumber.value || "", phoneNumber.validations);
    } else if (item.__typename === "EGDSTextAreaInputField") {
      var _item_egdsElementId1;
      var egdsElementId1 = (_item_egdsElementId1 = item.egdsElementId) !== null && _item_egdsElementId1 !== void 0 ? _item_egdsElementId1 : inquiryFormFieldSelector.MESSAGE;
      var _item_value;
      initialFormData[egdsElementId1] = returnInitialStateObject(egdsElementId1, item.__typename, (_item_value = item.value) !== null && _item_value !== void 0 ? _item_value : "", item.validations);
    }
    return initialFormData;
  }, {});
  return {
    formValue: updatedFormData,
    datePickerAvailability: datePickerAvailability,
    travelerSelector: travelerSelector
  };
};
var useInquiryFormValueManager = function (form, datePickerAvailability, travelerSelector) {
  var _useState2 = _sliced_to_array(useState2(getFormStateData(form.formInput, datePickerAvailability, travelerSelector)), 2),
    formState = _useState2[0],
    setFormState = _useState2[1];
  var getFormValue = useCallback(function () {
    return formState;
  }, [formState]);
  var setControlValue = function (param) {
    var id = param.id,
      value = param.value,
      error = param.error;
    setFormState(function (prevState) {
      var _prevState_formValue;
      return _object_spread_props(_object_spread({}, prevState), {
        formValue: _object_spread_props(_object_spread({}, prevState.formValue), _define_property({}, id, _object_spread_props(_object_spread({}, prevState === null || prevState === void 0 ? void 0 : (_prevState_formValue = prevState.formValue) === null || _prevState_formValue === void 0 ? void 0 : _prevState_formValue[id]), {
          value: value,
          error: error
        })))
      });
    });
  };
  var setCheckboxControl = function (param) {
    var id = param.id,
      value = param.value;
    setFormState(function (prevState) {
      var _prevState_formValue;
      return _object_spread_props(_object_spread({}, prevState), {
        formValue: _object_spread_props(_object_spread({}, prevState.formValue), _define_property({}, id, _object_spread_props(_object_spread({}, prevState === null || prevState === void 0 ? void 0 : (_prevState_formValue = prevState.formValue) === null || _prevState_formValue === void 0 ? void 0 : _prevState_formValue[id]), {
          checked: value
        })))
      });
    });
  };
  var setTravelerSelectorValue = useCallback(function (param) {
    var travelerSelectorValue = param.travelerSelectorValue;
    var updatedState = _object_spread_props(_object_spread({}, formState), {
      travelerSelector: travelerSelectorValue
    });
    setFormState(updatedState);
  }, [formState]);
  var setDatePickerAvailabilityValue = useCallback(function (param) {
    var checkInDate = param.checkInDate,
      checkOutDate = param.checkOutDate;
    var updatedState = _object_spread_props(_object_spread({}, formState), {
      datePickerAvailability: _object_spread_props(_object_spread({}, formState === null || formState === void 0 ? void 0 : formState.datePickerAvailability), {
        checkInDate: checkInDate,
        checkOutDate: checkOutDate
      })
    });
    setFormState(updatedState);
  }, [formState]);
  var createFormValueElement = function (element, error, updatedFormState) {
    var _updatedFormState_formValue;
    return _define_property({}, element.id, _object_spread_props(_object_spread({}, (_updatedFormState_formValue = updatedFormState.formValue) === null || _updatedFormState_formValue === void 0 ? void 0 : _updatedFormState_formValue[element.id]), {
      error: error
    }));
  };
  var validate = useCallback(function () {
    var inquiryFormValidationErrors = [];
    var updatedFormState = Object.values((formState === null || formState === void 0 ? void 0 : formState.formValue) || {}).reduce(function (acc, element) {
      var currentFormState = _object_spread({}, acc);
      var actOnServerDefinedValidation = getClientsideValidations(element.validations).actOnServerDefinedValidation;
      var currentValue = validateAndGetValues(element.typename, element.value).currentValue;
      var error = actOnServerDefinedValidation(currentValue);
      if (error === null || error === void 0 ? void 0 : error.invalid) {
        inquiryFormValidationErrors.push({
          inputId: element.id,
          message: error.invalid
        });
        return _object_spread_props(_object_spread({}, currentFormState), {
          formValue: _object_spread({}, currentFormState.formValue, createFormValueElement(element, error, currentFormState))
        });
      }
      return currentFormState;
    }, formState);
    setFormState(updatedFormState);
    return !inquiryFormValidationErrors.length;
  }, [formState]);
  return {
    setControlValue: setControlValue,
    setCheckboxControl: setCheckboxControl,
    setDatePickerAvailabilityValue: setDatePickerAvailabilityValue,
    setTravelerSelectorValue: setTravelerSelectorValue,
    getFormValue: getFormValue,
    formState: formState,
    validate: validate
  };
};
var InquiryFormContext = React7.createContext({});
var useInquiryFormContext = function () {
  return React7.useContext(InquiryFormContext);
};
// src/components/contact-host/__private/__fragments/inquiry-form/controls/inquiry-form-field.tsx
import React13 from "react";
import { gql as gql16 } from "@apollo/client";
// src/components/contact-host/__private/__fragments/controls/common/checkbox/egds-basic-checkbox.tsx
import React8 from "react";
import { gql as gql11 } from "@apollo/client";
import { EGDSCheckbox } from "@egds/react-core/checkbox";
import { useClickTracker as useClickTracker3 } from "@shared-ui/clickstream-analytics-context";
var __Fragment3 = gql11(_templateObject10());
var EGDSBasicCheckBox = function (param) {
  var data = param.data,
    checked = param.checked,
    onChange = param.onChange;
  var _React8_useState = _sliced_to_array(React8.useState(checked), 2),
    isChecked = _React8_useState[0],
    setIsChecked = _React8_useState[1];
  var track = useClickTracker3();
  var handleChange = React8.useCallback(function (event) {
    if (data.checkedAnalytics && !isChecked) {
      var _data_checkedAnalytics = data.checkedAnalytics,
        referrerId = _data_checkedAnalytics.referrerId,
        linkName = _data_checkedAnalytics.linkName;
      track(referrerId, linkName);
    }
    if (data.uncheckedAnalytics && isChecked) {
      var _data_uncheckedAnalytics = data.uncheckedAnalytics,
        referrerId1 = _data_uncheckedAnalytics.referrerId,
        linkName1 = _data_uncheckedAnalytics.linkName;
      track(referrerId1, linkName1);
    }
    setIsChecked(event.currentTarget.checked);
    if (onChange) {
      onChange(event);
    }
  }, [data.checkedAnalytics, data.uncheckedAnalytics, isChecked, onChange, track]);
  if (!data.egdsElementId) {
    return null;
  }
  var _data_description, _data_name;
  return /* @__PURE__ */React8.createElement(EGDSCheckbox, {
    id: data.egdsElementId,
    checked: checked,
    description: (_data_description = data.description) !== null && _data_description !== void 0 ? _data_description : void 0,
    disabled: !data.enabled,
    name: (_data_name = data.name) !== null && _data_name !== void 0 ? _data_name : void 0,
    onChange: handleChange,
    required: data.required
  }, data.checkboxLabel.text);
};
EGDSBasicCheckBox.displayName = "EGDSBasicCheckBoxFragment";
EGDSBasicCheckBox.fragment = _object_spread_props(_object_spread({}, __Fragment3), {
  __typename: "EGDSBasicCheckBox"
});
// src/components/contact-host/__private/__fragments/controls/egds-input-text.tsx
import React9 from "react";
import { gql as gql12 } from "@apollo/client";
import { EGDSTextInput } from "@egds/react-core/input";
var fragment8 = gql12(_templateObject11(), fragment7);
var EGDSInputText = function (props) {
  var data = props.data,
    value = props.value,
    errorMessage = props.errorMessage,
    onChange = props.onChange,
    onBlur = props.onBlur;
  var egdsElementId = data.egdsElementId,
    label = data.label,
    placeholder = data.placeholder,
    inputDisabled = data.inputDisabled;
  return /* @__PURE__ */React9.createElement(EGDSTextInput, {
    id: egdsElementId || "",
    invalid: errorMessage,
    value: value || "",
    label: label,
    disabled: inputDisabled || false,
    required: false,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : void 0,
    onBlur: onBlur,
    onChange: onChange
  });
};
EGDSInputText.displayName = "EGDSInputText";
EGDSInputText.fragment = fragment8;
// src/components/contact-host/__private/__fragments/controls/egds-text-area-input.tsx
import React10, { useEffect as useEffect2, useState as useState3 } from "react";
import { gql as gql13 } from "@apollo/client";
import { EGDSTextArea } from "@egds/react-core/input";
var fragment9 = gql13(_templateObject12(), fragment7);
var EGDSTextAreaInputField = function (props) {
  var data = props.data,
    value = props.value,
    errorMessage = props.errorMessage,
    onChange = props.onChange,
    onBlur = props.onBlur,
    instructions = props.instructions;
  var egdsElementId = data.egdsElementId,
    minRows = data.minRows,
    maxRows = data.maxRows,
    label = data.label,
    placeholder = data.placeholder;
  var _useState3 = _sliced_to_array(useState3(true), 2),
    isTextValid = _useState3[0],
    setIsTextValid = _useState3[1];
  useEffect2(function () {
    if (errorMessage) {
      setIsTextValid(false);
    } else {
      setIsTextValid(true);
    }
  }, [errorMessage]);
  return /* @__PURE__ */React10.createElement("div", null, /* @__PURE__ */React10.createElement(EGDSTextArea, {
    id: egdsElementId || "",
    invalid: !isTextValid ? instructions : "",
    value: value,
    name: label,
    label: label,
    required: false,
    minRows: minRows || void 0,
    maxRows: maxRows || void 0,
    placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : void 0,
    onBlur: onBlur,
    onChange: onChange,
    instruction: isTextValid ? instructions : ""
  }));
};
EGDSTextAreaInputField.displayName = "EGDSTextAreaInputField";
EGDSTextAreaInputField.fragment = fragment9;
// src/components/contact-host/__private/__fragments/inquiry-form/utils/input-field-utils.ts
var isMaxLengthValidation = function (element) {
  return (element === null || element === void 0 ? void 0 : element.__typename) === "EGDSMaxLengthInputValidation";
};
var getMaxLength = function (validations) {
  var maxLengthValidation = validations === null || validations === void 0 ? void 0 : validations.find(function (validation) {
    return validation.__typename === "EGDSMaxLengthInputValidation";
  });
  return isMaxLengthValidation(maxLengthValidation) ? maxLengthValidation === null || maxLengthValidation === void 0 ? void 0 : maxLengthValidation.maxLength : Number.MAX_SAFE_INTEGER;
};
var getInstruction = function (value, validations, errorMessage) {
  return {
    primary: errorMessage || "",
    secondary: "".concat(value ? value.length : 0, "/").concat(getMaxLength(validations))
  };
};
// src/components/contact-host/__private/__fragments/inquiry-form/control-state/use-inquiry-form-control-state.tsx
var useInquiryFormControlState = function (args) {
  var _currentFormState_formValue_id, _currentFormState_formValue, _currentFormState_formValue_id1, _currentFormState_formValue1;
  var inquiryFormValueManager = useInquiryFormContext().inquiryFormValueManager;
  var inputComponent = args.inputComponent;
  var hasInputValidations = function (input) {
    return "validations" in input;
  };
  var validationsForInputComponent = hasInputValidations(inputComponent) ? inputComponent.validations : void 0;
  var _inputComponent_egdsElementId;
  var id = "egdsElementId" in inputComponent ? (_inputComponent_egdsElementId = inputComponent.egdsElementId) !== null && _inputComponent_egdsElementId !== void 0 ? _inputComponent_egdsElementId : "" : "";
  var currentFormState = inquiryFormValueManager === null || inquiryFormValueManager === void 0 ? void 0 : inquiryFormValueManager.formState;
  if (!args.inputComponent || !currentFormState || !id) {
    return null;
  }
  var __typename = inputComponent.__typename;
  var _currentFormState_formValue_id_value;
  var value = (_currentFormState_formValue_id_value = (_currentFormState_formValue = currentFormState.formValue) === null || _currentFormState_formValue === void 0 ? void 0 : (_currentFormState_formValue_id = _currentFormState_formValue[id]) === null || _currentFormState_formValue_id === void 0 ? void 0 : _currentFormState_formValue_id.value) !== null && _currentFormState_formValue_id_value !== void 0 ? _currentFormState_formValue_id_value : "";
  var error = (_currentFormState_formValue1 = currentFormState.formValue) === null || _currentFormState_formValue1 === void 0 ? void 0 : (_currentFormState_formValue_id1 = _currentFormState_formValue1[id]) === null || _currentFormState_formValue_id1 === void 0 ? void 0 : _currentFormState_formValue_id1.error;
  var actOnServerDefinedValidation = getClientsideValidations(validationsForInputComponent || []).actOnServerDefinedValidation;
  var setControlValue = function (updatedControlValue, validationError) {
    inquiryFormValueManager === null || inquiryFormValueManager === void 0 ? void 0 : inquiryFormValueManager.setControlValue({
      id: id,
      value: updatedControlValue,
      typename: __typename,
      error: validationError
    });
  };
  var onBlur = function (event) {
    var updatedControlValue = event.target.value;
    var valueWithoutSpaces = clearSpaces(updatedControlValue);
    var validationError = actOnServerDefinedValidation(valueWithoutSpaces);
    var currentValue = validateAndGetValues(__typename, valueWithoutSpaces, value).currentValue;
    setControlValue(currentValue, validationError);
  };
  var onChange = function (event) {
    if (event.target.type === "checkbox" && "checked" in event.target) {
      inquiryFormValueManager === null || inquiryFormValueManager === void 0 ? void 0 : inquiryFormValueManager.setCheckboxControl({
        id: id,
        value: event.target.checked,
        typename: __typename
      });
    } else {
      var updatedControlValue = event.target.value;
      var validationError = actOnServerDefinedValidation(updatedControlValue) || [];
      setControlValue(updatedControlValue, validationError);
    }
  };
  if (inputComponent.__typename === "EGDSTextAreaInputField") {
    var _error_invalid;
    var instructionsToReturn = getInstruction(value, validationsForInputComponent !== null && validationsForInputComponent !== void 0 ? validationsForInputComponent : [], (_error_invalid = error === null || error === void 0 ? void 0 : error.invalid) !== null && _error_invalid !== void 0 ? _error_invalid : "");
    return {
      value: value,
      invalid: "",
      instructions: instructionsToReturn,
      onChange: onChange,
      onBlur: onBlur
    };
  }
  return {
    value: value,
    invalid: "",
    onChange: onChange,
    onBlur: onBlur
  };
};
// src/components/contact-host/__private/__fragments/inquiry-form/controls/inquiry-form-phone-input.tsx
import React12 from "react";
import { gql as gql15 } from "@apollo/client";
import { EGDSLayoutFlex as EGDSLayoutFlex3, EGDSLayoutFlexItem as EGDSLayoutFlexItem3 } from "@egds/react-core/layout-flex";
// src/components/contact-host/__private/__fragments/controls/egds-input-single-select.tsx
import React11 from "react";
import { gql as gql14 } from "@apollo/client";
import { EGDSSelect } from "@egds/react-core/input";
var fragment10 = gql14(_templateObject13());
var EGDSInputSingleSelect = function (props) {
  var data = props.data,
    value = props.value,
    onChange = props.onChange,
    onBlur = props.onBlur;
  var egdsElementId = data.egdsElementId,
    label = data.label,
    disabled = data.disabled,
    options = data.options;
  var _React11_useMemo = _sliced_to_array(React11.useMemo(function () {
      return options.filter(function (param) {
        var selected = param.selected;
        return selected;
      });
    }, [options]), 1),
    selectedOption = _React11_useMemo[0];
  var selectedValue = value !== null && value !== void 0 ? value : "";
  return /* @__PURE__ */React11.createElement(EGDSSelect, {
    id: egdsElementId || "",
    disabled: disabled,
    value: selectedValue || "",
    label: label || "",
    required: false,
    onBlur: onBlur,
    onChange: onChange,
    emptyState: !value && !selectedOption
  }, /* @__PURE__ */React11.createElement(React11.Fragment, null, options.map(function (option) {
    return /* @__PURE__ */React11.createElement("option", {
      key: option.label,
      value: option.label,
      label: option.label === selectedValue ? option.value : option.label
    });
  })));
};
EGDSInputSingleSelect.displayName = "EGDSInputSingleSelect";
EGDSInputSingleSelect.fragment = fragment10;
// src/components/contact-host/__private/__fragments/inquiry-form/controls/inquiry-form-phone-input.tsx
var __Fragment4 = gql15(_templateObject14(), EGDSInputSingleSelect.fragment, EGDSInputText.fragment);
var InquiryPhoneInputField = function (param) {
  var data = param.data,
    formValue = param.formValue;
  var _phoneFieldData_error;
  var countryCode = data.countryCode,
    phoneNumber = data.phoneNumber;
  var countryCodeData = formValue && formValue[countryCode.egdsElementId || ""];
  var phoneFieldData = formValue && formValue[phoneNumber.egdsElementId || ""];
  var inputPropsForCountryCode = useInquiryFormControlState({
    inputComponent: countryCode
  });
  var inputPropsForPhoneField = useInquiryFormControlState({
    inputComponent: phoneNumber
  });
  var handleCountryCodeEvent = function (handler) {
    return function (event) {
      handler(event);
      event.stopPropagation();
    };
  };
  return /* @__PURE__ */React12.createElement(EGDSLayoutFlex3, {
    tag: "div",
    space: "three",
    direction: "row"
  }, /* @__PURE__ */React12.createElement(EGDSLayoutFlexItem3, {
    maxWidth: "37x",
    grow: 1
  }, /* @__PURE__ */React12.createElement("div", null, /* @__PURE__ */React12.createElement(EGDSInputSingleSelect, {
    data: countryCode,
    value: countryCodeData === null || countryCodeData === void 0 ? void 0 : countryCodeData.value,
    onBlur: handleCountryCodeEvent(inputPropsForCountryCode === null || inputPropsForCountryCode === void 0 ? void 0 : inputPropsForCountryCode.onBlur),
    onChange: handleCountryCodeEvent(inputPropsForCountryCode === null || inputPropsForCountryCode === void 0 ? void 0 : inputPropsForCountryCode.onChange)
  }))), /* @__PURE__ */React12.createElement(EGDSLayoutFlexItem3, {
    grow: 1
  }, /* @__PURE__ */React12.createElement("div", null, /* @__PURE__ */React12.createElement(EGDSInputText, {
    data: phoneNumber,
    value: (phoneFieldData === null || phoneFieldData === void 0 ? void 0 : phoneFieldData.value) || "",
    errorMessage: phoneFieldData === null || phoneFieldData === void 0 ? void 0 : (_phoneFieldData_error = phoneFieldData.error) === null || _phoneFieldData_error === void 0 ? void 0 : _phoneFieldData_error.invalid,
    onBlur: inputPropsForPhoneField === null || inputPropsForPhoneField === void 0 ? void 0 : inputPropsForPhoneField.onBlur,
    onChange: inputPropsForPhoneField === null || inputPropsForPhoneField === void 0 ? void 0 : inputPropsForPhoneField.onChange
  }))));
};
InquiryPhoneInputField.displayName = "InquiryPhoneInputField";
InquiryPhoneInputField.fragment = __Fragment4;
// src/components/contact-host/__private/__fragments/inquiry-form/controls/inquiry-form-field.tsx
var fragment11 = gql16(_templateObject15(), EGDSInputText.fragment, EGDSBasicCheckBox.fragment, EGDSTextAreaInputField.fragment, InquiryPhoneInputField.fragment);
var InquiryFormField = function (param) {
  var data = param.data,
    formValues = param.formValues;
  var getFormValue = function (element, formValue) {
    var _element_egdsElementId;
    var elementId = (_element_egdsElementId = element.egdsElementId) !== null && _element_egdsElementId !== void 0 ? _element_egdsElementId : "";
    var formValueElement = formValue === null || formValue === void 0 ? void 0 : formValue[elementId];
    var _formValueElement_checked, _formValueElement_value;
    return {
      checked: (_formValueElement_checked = formValueElement === null || formValueElement === void 0 ? void 0 : formValueElement.checked) !== null && _formValueElement_checked !== void 0 ? _formValueElement_checked : false,
      value: (_formValueElement_value = formValueElement === null || formValueElement === void 0 ? void 0 : formValueElement.value) !== null && _formValueElement_value !== void 0 ? _formValueElement_value : "",
      errorMessage: formValueElement === null || formValueElement === void 0 ? void 0 : formValueElement.error
    };
  };
  var inputProps = useInquiryFormControlState({
    inputComponent: data
  });
  switch (data.__typename) {
    case "EGDSTextInputField":
      {
        return /* @__PURE__ */React13.createElement(EGDSInputText, {
          data: data,
          value: data.value || ""
        });
      }
    case "OffersInquiryPhoneInputField":
      {
        return /* @__PURE__ */React13.createElement(InquiryPhoneInputField, {
          data: data,
          formValue: formValues.formValue
        });
      }
    case "EGDSTextAreaInputField":
      {
        var _getFormValue_errorMessage;
        var _getFormValue_errorMessage_invalid;
        return /* @__PURE__ */React13.createElement(EGDSTextAreaInputField, {
          data: data,
          value: getFormValue(data, formValues.formValue).value,
          onBlur: inputProps === null || inputProps === void 0 ? void 0 : inputProps.onBlur,
          onChange: inputProps === null || inputProps === void 0 ? void 0 : inputProps.onChange,
          errorMessage: (_getFormValue_errorMessage_invalid = (_getFormValue_errorMessage = getFormValue(data, formValues.formValue).errorMessage) === null || _getFormValue_errorMessage === void 0 ? void 0 : _getFormValue_errorMessage.invalid) !== null && _getFormValue_errorMessage_invalid !== void 0 ? _getFormValue_errorMessage_invalid : "",
          instructions: inputProps === null || inputProps === void 0 ? void 0 : inputProps.instructions
        });
      }
    case "EGDSBasicCheckBox":
      {
        return /* @__PURE__ */React13.createElement(EGDSBasicCheckBox, {
          data: data,
          checked: getFormValue(data, formValues.formValue).checked,
          onChange: function (event) {
            inputProps === null || inputProps === void 0 ? void 0 : inputProps.onChange(event);
          }
        });
      }
    default:
      return null;
  }
};
InquiryFormField.displayName = "InquiryFormField";
InquiryFormField.fragment = fragment11;
// src/components/contact-host/__private/__fragments/inquiry-form/inquiry-form-provider.tsx
import React14 from "react";
var InquiryFormProvider = function (param) {
  var inquiryFormContext = param.inquiryFormContext,
    children = param.children;
  return /* @__PURE__ */React14.createElement(InquiryFormContext.Provider, {
    value: inquiryFormContext
  }, children);
};
// src/components/contact-host/__private/__fragments/inquiry-form/inquiry-form.tsx
var __inquiryFormFragment = gql17(_templateObject16(), InquiryFormButton.fragment, InquiryFormField.fragment, InquiryFormDisclaimer.fragment, EGDSStandardMessagingCard.fragment, OffersInquiryFormBookNowMessaging.fragment);
var _MUTATION = gql17(_templateObject17(), ConfirmationScreen.fragment);
var checkIsPetsIncluded = function (item) {
  return item.id === "amenities" && item.value === "PETS" || item.id === "house_rules_group" && item.value === "pets_allowed";
};
var InquiryForm = function (props) {
  var _inputs_inquiryFormInput_primaryPropertyCriteriaInput, _inputs_inquiryFormInput, _inputs_searchCriteria_primary_rooms_, _inputs_searchCriteria_primary, _inputs_searchCriteria, _inputs_searchCriteria_primary_rooms_1, _inputs_searchCriteria_primary1, _inputs_searchCriteria1, _inputs_searchCriteria_secondary_selections, _inputs_searchCriteria_secondary, _inputs_searchCriteria2, _data_formInput, _mutationResponse_submitInquiry;
  var data = props.data,
    propertyId = props.propertyId,
    onDialogClose = props.onDialogClose,
    triggerRef = props.triggerRef,
    refetchQuery = props.refetchQuery;
  var exposure = useExperiment("Add_Availability_and_Book_button_to_Contact_Host").exposure;
  var _useContactHostContext = useContactHostContext(),
    setInquiryUpdatedFields = _useContactHostContext.setInquiryUpdatedFields,
    inquiryUpdatedFields = _useContactHostContext.inquiryUpdatedFields,
    inputs = _useContactHostContext.inputs,
    isLoading = _useContactHostContext.isLoading,
    variables = _useContactHostContext.variables,
    setVariables = _useContactHostContext.setVariables;
  var dateRangeInput = inputs === null || inputs === void 0 ? void 0 : (_inputs_inquiryFormInput = inputs.inquiryFormInput) === null || _inputs_inquiryFormInput === void 0 ? void 0 : (_inputs_inquiryFormInput_primaryPropertyCriteriaInput = _inputs_inquiryFormInput.primaryPropertyCriteriaInput) === null || _inputs_inquiryFormInput_primaryPropertyCriteriaInput === void 0 ? void 0 : _inputs_inquiryFormInput_primaryPropertyCriteriaInput.dateRange;
  var childrenInput = inputs === null || inputs === void 0 ? void 0 : (_inputs_searchCriteria = inputs.searchCriteria) === null || _inputs_searchCriteria === void 0 ? void 0 : (_inputs_searchCriteria_primary = _inputs_searchCriteria.primary) === null || _inputs_searchCriteria_primary === void 0 ? void 0 : (_inputs_searchCriteria_primary_rooms_ = _inputs_searchCriteria_primary.rooms[0]) === null || _inputs_searchCriteria_primary_rooms_ === void 0 ? void 0 : _inputs_searchCriteria_primary_rooms_.children;
  var _inputs_searchCriteria_primary_rooms__adults;
  var travelerSelectorInput = {
    adults: (_inputs_searchCriteria_primary_rooms__adults = inputs === null || inputs === void 0 ? void 0 : (_inputs_searchCriteria1 = inputs.searchCriteria) === null || _inputs_searchCriteria1 === void 0 ? void 0 : (_inputs_searchCriteria_primary1 = _inputs_searchCriteria1.primary) === null || _inputs_searchCriteria_primary1 === void 0 ? void 0 : (_inputs_searchCriteria_primary_rooms_1 = _inputs_searchCriteria_primary1.rooms[0]) === null || _inputs_searchCriteria_primary_rooms_1 === void 0 ? void 0 : _inputs_searchCriteria_primary_rooms_1.adults) !== null && _inputs_searchCriteria_primary_rooms__adults !== void 0 ? _inputs_searchCriteria_primary_rooms__adults : 1,
    children: (childrenInput === null || childrenInput === void 0 ? void 0 : childrenInput.map(function (param) {
      var age = param.age;
      return "".concat(1, "_").concat(age);
    })) || [],
    isPetsIncluded: (inputs === null || inputs === void 0 ? void 0 : (_inputs_searchCriteria2 = inputs.searchCriteria) === null || _inputs_searchCriteria2 === void 0 ? void 0 : (_inputs_searchCriteria_secondary = _inputs_searchCriteria2.secondary) === null || _inputs_searchCriteria_secondary === void 0 ? void 0 : (_inputs_searchCriteria_secondary_selections = _inputs_searchCriteria_secondary.selections) === null || _inputs_searchCriteria_secondary_selections === void 0 ? void 0 : _inputs_searchCriteria_secondary_selections.some(checkIsPetsIncluded)) || false
  };
  var inquiryFormValueManager = useInquiryFormValueManager(data, dateRangeInput, travelerSelectorInput);
  var getFormValue = inquiryFormValueManager.getFormValue,
    setDatePickerAvailabilityValue = inquiryFormValueManager.setDatePickerAvailabilityValue,
    setTravelerSelectorValue = inquiryFormValueManager.setTravelerSelectorValue,
    formState = inquiryFormValueManager.formState;
  var _useMutation = _sliced_to_array(useMutation(_MUTATION), 2),
    mutation = _useMutation[0],
    _useMutation_ = _useMutation[1],
    mutationResponse = _useMutation_.data,
    mutationError = _useMutation_.error,
    mutationLoading = _useMutation_.loading;
  var context = useBexApi().context;
  var startDateRef = React15.useRef(null);
  var endDateRef = React15.useRef(null);
  var dateRangeAvailability = dateRangeInput ? {
    end: dateRangeInput.checkOutDate,
    start: dateRangeInput.checkInDate
  } : null;
  var track = useEgClickstream();
  var updateVariables = function (rooms, petsIncluded, dateRangeNew, dateChange) {
    var _variables_inquiryFormInput, _variables_searchCriteria;
    if ((variables === null || variables === void 0 ? void 0 : (_variables_inquiryFormInput = variables.inquiryFormInput) === null || _variables_inquiryFormInput === void 0 ? void 0 : _variables_inquiryFormInput.primaryPropertyCriteriaInput) && (variables === null || variables === void 0 ? void 0 : (_variables_searchCriteria = variables.searchCriteria) === null || _variables_searchCriteria === void 0 ? void 0 : _variables_searchCriteria.primary) && exposure.bucket === 1) {
      var newVariables = _object_spread_props(_object_spread({}, variables), {
        inquiryFormInput: _object_spread(_object_spread_props(_object_spread({}, variables.inquiryFormInput), {
          primaryPropertyCriteriaInput: _object_spread({}, variables.inquiryFormInput.primaryPropertyCriteriaInput, rooms !== void 0 && {
            rooms: rooms
          }, dateChange && {
            dateRange: dateRangeNew ? {
              checkInDate: dateRangeNew.selectedStartDate,
              checkOutDate: dateRangeNew.selectedEndDate
            } : null
          })
        }), petsIncluded !== void 0 && {
          petsIncluded: petsIncluded
        }),
        searchCriteria: _object_spread_props(_object_spread({}, variables.searchCriteria), {
          primary: _object_spread({}, variables.searchCriteria.primary, rooms !== void 0 && {
            rooms: rooms
          }, dateChange && {
            dateRange: dateRangeNew ? {
              checkInDate: dateRangeNew.selectedStartDate,
              checkOutDate: dateRangeNew.selectedEndDate
            } : null
          })
        })
      });
      setVariables(newVariables);
      refetchQuery(newVariables);
    }
  };
  var onChangeDatePickerValueAvailability = function (selectedStartDate, selectedEndDate) {
    var datePickerAvailabilityValue = {
      checkInDate: selectedStartDate ? parseDate(selectedStartDate) : null,
      checkOutDate: selectedEndDate ? parseDate(selectedEndDate) : null
    };
    setDatePickerAvailabilityValue(datePickerAvailabilityValue);
    var datePickerAvailabilityFlag = (datePickerAvailabilityValue === null || datePickerAvailabilityValue === void 0 ? void 0 : datePickerAvailabilityValue.checkInDate) && (datePickerAvailabilityValue === null || datePickerAvailabilityValue === void 0 ? void 0 : datePickerAvailabilityValue.checkOutDate);
    var payload = datePickerAvailabilityFlag ? {
      selectedStartDate: datePickerAvailabilityValue.checkInDate,
      selectedEndDate: datePickerAvailabilityValue.checkOutDate
    } : void 0;
    setInquiryUpdatedFields(_object_spread_props(_object_spread({}, inquiryUpdatedFields), {
      dateRange: payload,
      dateChange: true
    }));
    updateVariables(void 0, void 0, payload, true);
  };
  var updateStoreWithTravelerUrlData = function (travelerSelectorPayload) {
    setTravelerSelectorValue({
      travelerSelectorValue: travelerSelectorPayload
    });
    var rooms = [payloadToRoomInput(travelerSelectorPayload)];
    var petsIncluded = travelerSelectorPayload.isPetsIncluded;
    setInquiryUpdatedFields(_object_spread_props(_object_spread({}, inquiryUpdatedFields), {
      rooms: rooms,
      petsIncluded: petsIncluded
    }));
    updateVariables(rooms, petsIncluded, void 0, false);
  };
  var initialState = useMemo(function () {
    var travelerSelector = formState.travelerSelector;
    if (!travelerSelector) {
      return void 0;
    }
    var currentState = _object_spread_props(_object_spread({}, payloadToRoomInput(travelerSelector)), {
      petsIncluded: travelerSelector.isPetsIncluded
    });
    return currentState;
  }, [formState]);
  var onFormSubmit = function () {
    var inquiryRequestInput = buildPrimaryPropertyCriteriaPayload(inquiryFormValueManager.formState, propertyId);
    if (inquiryFormValueManager.validate()) {
      mutation({
        variables: {
          context: context,
          inquiryRequestInput: inquiryRequestInput
        }
      }).then(function (r) {
        var dateRange;
        var rooms;
        var petsIncluded;
        var _inquiryFormValueManager_formState = inquiryFormValueManager.formState,
          datePickerAvailability = _inquiryFormValueManager_formState.datePickerAvailability,
          travelerSelector = _inquiryFormValueManager_formState.travelerSelector;
        if ((datePickerAvailability === null || datePickerAvailability === void 0 ? void 0 : datePickerAvailability.checkInDate) && (datePickerAvailability === null || datePickerAvailability === void 0 ? void 0 : datePickerAvailability.checkOutDate)) {
          dateRange = {
            selectedStartDate: datePickerAvailability.checkInDate,
            selectedEndDate: datePickerAvailability.checkOutDate
          };
        }
        if (travelerSelector) {
          rooms = [payloadToRoomInput(travelerSelector)];
          petsIncluded = travelerSelector.isPetsIncluded;
        }
        setInquiryUpdatedFields({
          dateRange: dateRange,
          rooms: rooms,
          petsIncluded: petsIncluded
        });
      });
    }
  };
  if (!(data === null || data === void 0 ? void 0 : (_data_formInput = data.formInput) === null || _data_formInput === void 0 ? void 0 : _data_formInput.length) || !(data === null || data === void 0 ? void 0 : data.submitButton)) {
    return null;
  }
  if (mutationResponse === null || mutationResponse === void 0 ? void 0 : (_mutationResponse_submitInquiry = mutationResponse.submitInquiry) === null || _mutationResponse_submitInquiry === void 0 ? void 0 : _mutationResponse_submitInquiry.doneButton) {
    return /* @__PURE__ */React15.createElement(ConfirmationScreen, {
      data: mutationResponse === null || mutationResponse === void 0 ? void 0 : mutationResponse.submitInquiry,
      onDialogClose: onDialogClose
    });
  }
  if (mutationError === null || mutationError === void 0 ? void 0 : mutationError.graphQLErrors.length) {
    track(buildEvent(SCHEMA_NAME, "ContactHostMessageFailed", IMPRESSION, "1.0.0" /* ONE_ZERO_ZERO */));
  }
  return /* @__PURE__ */React15.createElement(React15.Fragment, null, /* @__PURE__ */React15.createElement(EGDSSpacing4, {
    padding: {
      inlineend: "six",
      blockend: "three"
    }
  }, /* @__PURE__ */React15.createElement(EGDSLayoutFlex4, {
    alignItems: "start",
    justifyContent: "start",
    space: "four",
    direction: "column"
  }, /* @__PURE__ */React15.createElement(EGDSLayoutFlexItem4, null, /* @__PURE__ */React15.createElement(EGDSHeading2, {
    tag: "h2",
    size: 5
  }, data.header)), data.featuredMessage && /* @__PURE__ */React15.createElement(EGDSLayoutFlexItem4, {
    grow: 1
  }, /* @__PURE__ */React15.createElement(EGDSStandardMessagingCard, {
    data: data.featuredMessage
  })))), /* @__PURE__ */React15.createElement(Experiment, {
    name: "Add_Availability_and_Book_button_to_Contact_Host"
  }, /* @__PURE__ */React15.createElement(ExperimentControl, null), /* @__PURE__ */React15.createElement(ExperimentVariant, {
    bucket: 1
  }, !isLoading && /* @__PURE__ */React15.createElement(EGDSSpacing4, {
    margin: {
      blockend: "four"
    }
  }, data.bookNowMessaging && /* @__PURE__ */React15.createElement("div", null, /* @__PURE__ */React15.createElement(EGDSLayoutFlexItem4, {
    grow: 1
  }, /* @__PURE__ */React15.createElement(OffersInquiryFormBookNowMessaging, {
    data: data.bookNowMessaging
  })))))), /* @__PURE__ */React15.createElement(InquiryFormProvider, {
    inquiryFormContext: {
      inquiryFormValueManager: inquiryFormValueManager
    }
  }, /* @__PURE__ */React15.createElement(EGDSForm, {
    "data-stid": "lodging-inquiry-form",
    hasRequiredFieldIndicator: true
  }, /* @__PURE__ */React15.createElement(EGDSSpacing4, {
    margin: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React15.createElement(PropertyAvailability, {
    startDateRef: startDateRef,
    endDateRef: endDateRef,
    skipSsr: true,
    onSubmit: onChangeDatePickerValueAvailability,
    inputs: {
      eid: propertyId,
      dateRange: dateRangeAvailability
    },
    isNestDialog: true
  })), inputs && /* @__PURE__ */React15.createElement(EGDSSpacing4, {
    margin: {
      blockstart: "four"
    }
  }, /* @__PURE__ */React15.createElement("div", null, /* @__PURE__ */React15.createElement(TravelerSelector, {
    inputs: inputs,
    initialState: initialState,
    isNestDialog: true,
    dialogId: "internal-contact-host-traveler-selector",
    updateStoreWithTravelerUrlData: updateStoreWithTravelerUrlData,
    triggerRef: triggerRef
  }))), /* @__PURE__ */React15.createElement(EGDSLayoutFlex4, {
    tag: "div",
    direction: "column",
    space: "one",
    "data-stid": "inquiry-form-container"
  }, data.formInput.map(function (input, index) {
    return /* @__PURE__ */React15.createElement(EGDSSpacing4, {
      key: "InquiryFormField-".concat(index),
      margin: {
        blockstart: "four"
      }
    }, /* @__PURE__ */React15.createElement("div", null, /* @__PURE__ */React15.createElement(EGDSLayoutFlexItem4, {
      maxWidth: "half_width"
    }, /* @__PURE__ */React15.createElement(InquiryFormField, {
      data: input,
      formValues: getFormValue()
    }))));
  })), data.disclaimer ? /* @__PURE__ */React15.createElement(InquiryFormDisclaimer, {
    data: data
  }) : null, /* @__PURE__ */React15.createElement(EGDSSpacing4, {
    margin: {
      blockstart: "six"
    }
  }, /* @__PURE__ */React15.createElement("div", null, /* @__PURE__ */React15.createElement(InquiryFormButton, {
    onClick: onFormSubmit,
    localDisabled: mutationLoading,
    data: data.submitButton,
    showLoader: mutationLoading
  }))))));
};
InquiryForm.fragment = __inquiryFormFragment;
InquiryForm.displayName = "InquiryForm";
// src/components/contact-host/__private/__fragments/contact-host-inquiry-form-dialog.tsx
var _contactHostInquiryFormDialog = gql18(_templateObject18(), InquiryForm.fragment);
var Sheet = function (props) {
  var data = props.data,
    onDialogClose = props.onDialogClose,
    dialogId = props.dialogId,
    triggerRef = props.triggerRef,
    refetchQuery = props.refetchQuery;
  var propertyId = useContactHostContext().propertyId;
  var trackEvent = useEgClickstream2();
  var _obj;
  var isSmallView = useViewportMap2((_obj = {}, _define_property(_obj, ViewSizes2.SMALL, true), _define_property(_obj, ViewSizes2.MEDIUM, false), _define_property(_obj, ViewSizes2.LARGE, false), _obj));
  var triggerRefInquiry = useRef(null);
  var _useDialog = _sliced_to_array(useDialog(dialogId), 3),
    isDialogOpen = _useDialog[0],
    dialogActions = _useDialog[1],
    DialogComponent = _useDialog[2];
  useEffect3(function () {
    dialogActions.openDialog();
    trackEvent(inquiryFormViewedEvent());
  }, []);
  var closeDialog = function () {
    onDialogClose(false);
    dialogActions.closeDialog();
  };
  return /* @__PURE__ */React16.createElement(EGDSSheetTransition2, {
    isVisible: isDialogOpen
  }, /* @__PURE__ */React16.createElement(DialogComponent, null, /* @__PURE__ */React16.createElement(EGDSSheet2, {
    isVisible: isDialogOpen,
    triggerRef: triggerRefInquiry,
    type: isSmallView ? "full" : "centered"
  }, /* @__PURE__ */React16.createElement(EGDSToolbar, {
    navigationContent: {
      onClick: closeDialog,
      navIconLabel: "Close Toolbar"
    }
  }), /* @__PURE__ */React16.createElement(EGDSSheetContent2, null, /* @__PURE__ */React16.createElement(InquiryForm, {
    data: data,
    propertyId: propertyId,
    onDialogClose: closeDialog,
    triggerRef: triggerRef,
    refetchQuery: refetchQuery
  })))));
};
var ContactHostInquiryFormDialog = function (props) {
  var data = props.data,
    handleInquiryFormDialogVisibility = props.handleInquiryFormDialogVisibility,
    dialogId = props.dialogId,
    triggerRef = props.triggerRef,
    refetchQuery = props.refetchQuery;
  if (data === null || data === void 0 ? void 0 : data.inquiryFormModal) {
    return /* @__PURE__ */React16.createElement(Sheet, {
      data: data === null || data === void 0 ? void 0 : data.inquiryFormModal,
      onDialogClose: handleInquiryFormDialogVisibility,
      dialogId: dialogId,
      triggerRef: triggerRef,
      refetchQuery: refetchQuery
    });
  }
  return null;
};
ContactHostInquiryFormDialog.fragment = _contactHostInquiryFormDialog;
ContactHostInquiryFormDialog.displayName = "ContactHostInquiryFormDialog";
// src/components/contact-host/__private/__fragments/contact-host-button.tsx
var __contactHostButtonFragment = gql19(_templateObject19(), ContactHostInquiryFormDialog.fragment);
var DIALOG_ID = "contact-host-inquiry-form-dialog";
var usePrevious = function (value) {
  var ref = useRef2({
    search: ""
  });
  useEffect4(function () {
    ref.current = value;
  });
  return ref.current;
};
var ContactHostButton = function (param) {
  var onFieldsChangeCallback = param.onFieldsChangeCallback,
    data = param.data,
    triggerRef = param.triggerRef,
    refetchQuery = param.refetchQuery;
  var _useState4 = _sliced_to_array(useState4(false), 2),
    showInquiryFormDialog = _useState4[0],
    setShowInquiryFormDialog = _useState4[1];
  var search = useLocation().search;
  var trackEvent = useClickTracker4();
  var button = data.button,
    action = data.action;
  var _useDialog2 = _sliced_to_array(useDialog2(DIALOG_ID), 1),
    isDialogOpen = _useDialog2[0];
  var prevSearch = usePrevious({
    search: search
  });
  var _useContactHostContext = useContactHostContext(),
    isInquiryRoute = _useContactHostContext.isInquiryRoute,
    setIsInquiryRoute = _useContactHostContext.setIsInquiryRoute,
    inquiryUpdatedFields = _useContactHostContext.inquiryUpdatedFields,
    setInquiryUpdatedFields = _useContactHostContext.setInquiryUpdatedFields;
  useEffect4(function () {
    if (onFieldsChangeCallback && inquiryUpdatedFields && !showInquiryFormDialog) {
      var dateRange = inquiryUpdatedFields.dateRange,
        petsIncluded = inquiryUpdatedFields.petsIncluded,
        rooms = inquiryUpdatedFields.rooms,
        _inquiryUpdatedFields_dateChange = inquiryUpdatedFields.dateChange,
        dateChange = _inquiryUpdatedFields_dateChange === void 0 ? false : _inquiryUpdatedFields_dateChange;
      var payload = _object_spread({
        dateChange: dateChange,
        dateRange: dateRange ? {
          selectedStartDate: dateRange.selectedStartDate,
          selectedEndDate: dateRange.selectedEndDate
        } : void 0,
        rooms: rooms
      }, petsIncluded !== void 0 && {
        petsIncluded: petsIncluded
      });
      onFieldsChangeCallback(payload);
      setInquiryUpdatedFields(void 0);
    }
  }, [showInquiryFormDialog, inquiryUpdatedFields]);
  useEffect4(function () {
    if (search.includes("action=inquiry") && !isInquiryRoute) {
      setIsInquiryRoute(true);
      setShowInquiryFormDialog(true);
    }
  }, [search]);
  useEffect4(function () {
    if (!isDialogOpen && (!search.includes("action=inquiry") || search.includes("action=inquiry") && prevSearch.search.includes("action=inquiry"))) {
      setShowInquiryFormDialog(false);
    }
  }, [isDialogOpen]);
  var handleButtonClick = function (buttonAction) {
    if (button === null || button === void 0 ? void 0 : button.analytics) {
      var analytics = button.analytics;
      trackEvent(analytics.referrerId, analytics.linkName, true);
    }
    if ((buttonAction === null || buttonAction === void 0 ? void 0 : buttonAction.__typename) === "OffersInquiryFormDialogAction") {
      setShowInquiryFormDialog(true);
    }
  };
  var getButtonProps = function () {
    var buttonProps = {
      onClick: function () {
        return handleButtonClick(action);
      }
    };
    if ((action === null || action === void 0 ? void 0 : action.__typename) === "UILinkAction") {
      var resource = action.resource;
      buttonProps = _object_spread_props(_object_spread({}, buttonProps), {
        href: resource.value
      });
    }
    return buttonProps;
  };
  var renderButton = function () {
    switch (button === null || button === void 0 ? void 0 : button.__typename) {
      case "UISecondaryButton":
        return /* @__PURE__ */React17.createElement(EGDSSecondaryButton, _object_spread({
          "data-stid": "contact-host-secondary-button"
        }, getButtonProps()), button === null || button === void 0 ? void 0 : button.primary);
      case "UITertiaryButton":
        return /* @__PURE__ */React17.createElement(EGDSTertiaryButton2, _object_spread({
          "data-stid": "contact-host-tertiary-button"
        }, getButtonProps()), button === null || button === void 0 ? void 0 : button.primary);
      default:
        return null;
    }
  };
  return /* @__PURE__ */React17.createElement(React17.Fragment, null, button && renderButton(), (action === null || action === void 0 ? void 0 : action.__typename) === "OffersInquiryFormDialogAction" && showInquiryFormDialog && /* @__PURE__ */React17.createElement(ContactHostInquiryFormDialog, {
    dialogId: DIALOG_ID,
    data: action,
    handleInquiryFormDialogVisibility: setShowInquiryFormDialog,
    refetchQuery: refetchQuery,
    triggerRef: triggerRef
  }));
};
ContactHostButton.fragment = __contactHostButtonFragment;
ContactHostButton.displayName = "ContactHostButton";
// src/components/contact-host/__private/__fragments/contact-host-section.tsx
var __contactHostSectionFragment = gql20(_templateObject20(), ContactHostButton.fragment);
var ContactHostSection = function (param) {
  var data = param.data,
    onFieldsChangeCallback = param.onFieldsChangeCallback,
    triggerRef = param.triggerRef,
    refetchQuery = param.refetchQuery;
  var header = data.header,
    cta = data.cta;
  if (!cta) {
    return null;
  }
  var renderContactHostButtonWithheader = function () {
    return /* @__PURE__ */React18.createElement(EGDSCard2, null, /* @__PURE__ */React18.createElement(EGDSCardContentSection2, null, /* @__PURE__ */React18.createElement(EGDSSpacing5, {
      padding: {
        large: {
          inline: "three"
        },
        extra_large: {
          inline: "three"
        },
        blockstart: "three",
        blockend: "three"
      }
    }, /* @__PURE__ */React18.createElement(EGDSLayoutGrid, {
      space: "four",
      columns: {
        medium: 1,
        large: 3
      }
    }, /* @__PURE__ */React18.createElement(EGDSLayoutGridItem2, {
      colSpan: {
        medium: 1,
        large: 1
      },
      rowSpan: {
        medium: 1,
        large: 1
      }
    }, /* @__PURE__ */React18.createElement(EGDSHeading3, {
      tag: "h3",
      size: 4
    }, header)), /* @__PURE__ */React18.createElement(EGDSLayoutGridItem2, {
      colSpan: 1
    }, /* @__PURE__ */React18.createElement("div", null, /* @__PURE__ */React18.createElement(ContactHostButton, {
      data: cta,
      onFieldsChangeCallback: onFieldsChangeCallback,
      refetchQuery: refetchQuery,
      triggerRef: triggerRef
    })))))));
  };
  return /* @__PURE__ */React18.createElement(React18.Fragment, null, header ? renderContactHostButtonWithheader() : /* @__PURE__ */React18.createElement(ContactHostButton, {
    data: cta,
    onFieldsChangeCallback: onFieldsChangeCallback,
    refetchQuery: refetchQuery,
    triggerRef: triggerRef
  }));
};
ContactHostSection.fragment = __contactHostSectionFragment;
ContactHostSection.displayName = "ContactHostSection";
// src/components/contact-host/contact-host.tsx
var __Query = gql21(_templateObject21(), ContactHostSection.fragment);
var ContactHost = function (props) {
  var inputs = props.inputs,
    skipSsr = props.skipSsr,
    onFieldsChangeCallback = props.onFieldsChangeCallback,
    triggerRef = props.triggerRef;
  var context = useBexApi2().context;
  var _useContactHostContext = useContactHostContext(),
    setPropertyId = _useContactHostContext.setPropertyId,
    setInputs = _useContactHostContext.setInputs,
    setIsLoading = _useContactHostContext.setIsLoading,
    setVariables = _useContactHostContext.setVariables;
  setInputs(inputs);
  var InitialVariables = _object_spread_props(_object_spread({}, inputs), {
    context: context
  });
  useEffect5(function () {
    setVariables(InitialVariables);
  }, []);
  var _useState5 = _sliced_to_array(useState5(void 0), 2),
    contactHostData = _useState5[0],
    setContactHostData = _useState5[1];
  var propertyId = inputs.propertyId;
  propertyId && setPropertyId(propertyId);
  var _useQuery = useQuery(__Query, {
      context: {
        batchKey: "lodging-property-offers"
      },
      variables: InitialVariables,
      ssr: !skipSsr,
      notifyOnNetworkStatusChange: true
    }),
    data = _useQuery.data,
    error = _useQuery.error,
    loading = _useQuery.loading,
    refetch = _useQuery.refetch;
  useEffect5(function () {
    setIsLoading(loading);
    if (data === null || data === void 0 ? void 0 : data.offersContactHost) {
      setContactHostData(data);
    }
  }, [loading, data]);
  if (error || !(contactHostData === null || contactHostData === void 0 ? void 0 : contactHostData.offersContactHost)) {
    return null;
  }
  return /* @__PURE__ */React19.createElement(ContactHostSection, {
    data: contactHostData.offersContactHost,
    onFieldsChangeCallback: onFieldsChangeCallback,
    refetchQuery: refetch,
    triggerRef: triggerRef
  });
};
ContactHost.displayName = "sharedui-ContactHost";
export { ContactHost, ContactHostContextProvider };